import { designService } from '@paragon/data-connections';
import { enqueueError } from '@paragon/notification-tools';
import { notNullish } from '@paragon/utilities';

import { getBundlesByScheduleGroupGuid } from '../selectors/getBundlesByScheduleGroupGuid';
import { truckloadsLoaded } from '../store/truckloadsSlice';
import { loadComponentsForScheduleGroup } from './componentActions';
import { AsyncThunkActionVoid } from './thunkActions';

export function loadScheduleGroupData(scheduleGroupGuid: string): AsyncThunkActionVoid {
  return async function loadScheduleGroupDataThunkAction(dispatch, getState) {
    const state = getState();

    const bundlesForScheduleGroup = getBundlesByScheduleGroupGuid(state)[scheduleGroupGuid];
    const truckloadGuids = bundlesForScheduleGroup.map((bundle) => bundle.truckloadGuid).filter(notNullish);
    if (truckloadGuids.length > 0) {
      designService.truckloads
        .getForGuids(truckloadGuids)
        .then((truckloads) => void dispatch(truckloadsLoaded(truckloads)))
        .catch((error) => {
          dispatch(enqueueError('Error loading truckloads for Schedule Group'));
          console.error(error);
        });
    }

    await dispatch(loadComponentsForScheduleGroup(scheduleGroupGuid));
  };
}
